import React, { useEffect, useState } from 'react'
import "./C2.css";
import Product from "./Product"
import Carousel from 'react-bootstrap/Carousel'
import ProductSkeleton from './components/skeleton/ProductSkeleton';
import axios from "./axios"

function C4() {
    const [beverages,setBeverages]=useState([])
    const skeleton=[1,2,3,4,5,6,7,8]
    useEffect(()=>{
        axios({
            url:'/products/category/beverages',
            method:'get'
        }).then(res => setBeverages(res.data)).catch(err => console.log("eee",err))
    },[])
    return (
        <section className="contaier">
             <Carousel>
                <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1_DT_CXTT179_1200x300_25thmarch2021.jpg"
                    alt="First slide"
                    />
                    {/* <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
            </Carousel>
            <section className="container-fluid">
            <h5 className="ml-5 mt-4">Beverages</h5> 
            <article className="row">  
                    {
                        beverages.length>0?
                        beverages.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}
                            active={f.active}      
                            />
                              </article>
                        ):
                        skeleton.map(s=>
                            <article className='col-md-3 col-sm-4' key={s}>
                                <ProductSkeleton />
                            </article>
                       )
                    }
            </article>
            </section>   
        </section>
    )
}

export default C4
